import React from 'react';
import { CloudRain, Users } from 'lucide-react';

const NextWeekPlan = ({ plans }) => {
    return (
        <div className="bg-white rounded-2xl p-6 shadow-md h-full">
            <h3 className="text-sm font-bold text-gray-900 mb-4">Next Week&rsquo;s Plan</h3>
            <div className="flex flex-col gap-3 overflow-y-auto pr-1 min-h-[100px] max-h-[500px]">
                {plans?.length > 0 ? (
                    plans.map((plan) => (
                        <div key={plan.id} className="bg-[#F9FAFB] p-4 rounded-lg relative overflow-hidden flex flex-col justify-center min-h-[80px]">
                            {/* Left colored border line */}
                            {/* Left colored border line */}
                            <div className="absolute left-0 top-0 bottom-0 w-1" style={{ backgroundColor: plan.color || '#D4B95E' }}></div>

                            <h4 className="text-sm font-medium text-gray-900 mb-2 pl-2">{plan.title}</h4>

                            <div
                                className="inline-flex items-center gap-1.5 px-2 py-1 rounded border text-xs font-medium w-fit ml-2"
                                style={{
                                    backgroundColor: `${plan.color || '#D4B95E'}1A`, // 10% opacity
                                    color: plan.color || '#D4B95E',
                                    borderColor: plan.color || '#D4B95E'
                                }}
                            >
                                {plan.tag}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="flex flex-col items-center justify-center py-8 px-4">
                        {/* Icon */}
                        <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-purple-50 to-violet-50 flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-purple-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                            </svg>
                        </div>

                        {/* Main Message */}
                        <h4 className="text-gray-900 font-semibold text-base mb-2">
                            No Plans Yet
                        </h4>

                        {/* Descriptive Text */}
                        <p className="text-gray-500 text-sm text-center max-w-xs">
                            Next week&apos;s planned activities will appear here once they are scheduled.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NextWeekPlan;
